module.exports = __webpack_public_path__ + "assets/white-logo-d94e46.svg";